module.exports = __webpack_public_path__ + "static/media/A2.d6c262c2.jpg";